import PropTypes from 'prop-types';
import { useState } from 'react';
import { useTheme } from '@mui/material/styles';
import { Box, Drawer, Avatar, ButtonBase, useMediaQuery } from '@mui/material';
import PerfectScrollbar from 'react-perfect-scrollbar';
import { BrowserView, MobileView } from 'react-device-detect';

import MenuList from './MenuList';
import LogoSection from '../LogoSection';
import MenuCard from './MenuCard';
import { drawerWidth } from 'store/constant';
import logo from '../../../assets/images/jj_logo.png';
import TestModal from './TestModal';
import { getTestingUrl } from '../../../helpers/string-helper';
import { IconMenu2 } from '@tabler/icons';

const Sidebar = ({ drawerOpen, drawerToggle, window }) => {
  const theme = useTheme();
  const matchUpMd = useMediaQuery(theme.breakpoints.up('md'));

  const [modalOpen, setModalOpen] = useState(false);
  const [clickCount, setClickCount] = useState(0);

  const handleImageClick = () => {
    setClickCount(prev => prev + 1);
    if (clickCount === 1) {
      setModalOpen(true);
      setClickCount(0);
    }
  };

  const handleCloseModal = () => setModalOpen(false);
  const handleConfirm = () => {
    window.location.href = getTestingUrl();
  };

  const container = window !== undefined ? () => window.document.body : undefined;

  return (
    <Box component="nav" sx={{ flexShrink: 0, width: matchUpMd ? drawerWidth : 'auto' }} aria-label="sidebar">
      <Drawer
        container={container}
        variant={matchUpMd ? 'persistent' : 'temporary'}
        anchor="left"
        open={drawerOpen}
        onClose={drawerToggle}
        sx={{
          '& .MuiDrawer-paper': {
            width: drawerWidth,
            height: '100vh',
            display: 'flex',
            flexDirection: 'column',
            background: theme.palette.background.default,
            color: theme.palette.text.primary,
            borderRight: 'none'
          }
        }}
        ModalProps={{ keepMounted: true }}
      >
        {/* Fixed top section: toggle + logo */}
        <Box sx={{ display: 'flex', alignItems: 'center', p: 2 }}>
          <ButtonBase sx={{ borderRadius: '12px', overflow: 'hidden' }}>
            <Avatar
              variant="rounded"
              sx={{
                ...theme.typography.commonAvatar,
                ...theme.typography.mediumAvatar,
                transition: 'all .2s ease-in-out',
                background: theme.palette.secondary.light,
                color: theme.palette.secondary.dark,
                '&:hover': {
                  background: theme.palette.secondary.dark,
                  color: theme.palette.secondary.light
                }
              }}
              onClick={drawerToggle}
            >
              <IconMenu2 stroke={1.5} size="1.3rem" />
            </Avatar>
          </ButtonBase>
          <Box sx={{ ml: 2 }}>
            <LogoSection />
          </Box>
        </Box>

        {/* Scrollable content */}
        <Box sx={{ flexGrow: 1, overflow: 'hidden' }}>
          <PerfectScrollbar component="div" style={{ height: '100%', padding: '0 16px' }}>
            <BrowserView>
              <MenuList />
              <Box sx={{ display: 'flex', justifyContent: 'center', mt: 2 }}>
                <img
                  src={logo}
                  alt="JJ Logo"
                  style={{ maxWidth: '100%', width: 'auto', cursor: 'pointer' }}
                  onClick={handleImageClick}
                />
              </Box>
            </BrowserView>

            <MobileView>
              <MenuList />
              <MenuCard />
            </MobileView>
          </PerfectScrollbar>
        </Box>

        {/* Modal */}
        <TestModal open={modalOpen} onClose={handleCloseModal} onConfirm={handleConfirm} />
      </Drawer>
    </Box>
  );
};

Sidebar.propTypes = {
  drawerOpen: PropTypes.bool,
  drawerToggle: PropTypes.func,
  window: PropTypes.object
};

export default Sidebar;